import { createResourceActions } from 'utils/actionsGenerator';

import { types } from './reducer';

export const { patch } = createResourceActions({
    name: 'keywords',
    types,
    url: '/keywords',
});
